<router-outlet></router-outlet>
<kaz-cookie-banner></kaz-cookie-banner>
<kaz-toast></kaz-toast>
